import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { isValidEmail } from "../../common/helper";
import { emailService } from "../../services/EmailService";
export function ChangeEmailModal({
  submitChange,
  currentEmail,
  isOpen,
  setIsOpen
}) {
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  let { t } = useTranslation();

  useEffect(() => {
    setEmail(currentEmail);
  }, []);
  function closeModal() {
    setIsOpen(false);
  }
  function onChange({ target }) {
    setEmail(target.value);
  }
  function onSubmit() {
    setError();
    if (!email) {
      setError(t("The Email Address is required."));
      return;
    }
    if (!isValidEmail(email)) {
      setError(t("The Email Address is not valid."));
      return;
    }
    emailService.exist(email).then((data) => {
      if (data.exist)
        setError(t("There is already a candidate with this email"));
      else submitChange(email);
    });
  }

  return (
    <ModalContainer
      isOpen={isOpen}
      modalTitle={t("Change Email")}
      closeModal={closeModal}
      crossmarkAction={closeModal}
      cancelButtonAction={closeModal}
      cancelButtonTitle="Cancel"
      submitButtonTitle="Change"
      modalSize="lg"
      submitButtonAction={onSubmit}
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label className="label">{t("Email")}</label>
          {error && <span className="error-msg">{error}</span>}
        </div>
        <input
          name="recommendedEmail"
          type="text"
          value={email}
          placeholder={t("Name")}
          maxLength={100}
          onChange={onChange}
        />
      </div>
    </ModalContainer>
  );
}
